import { Dimension } from "../../API";

export const formatDimension = (dimension: Dimension): string => {
    let output = '';
    if (dimension.measurement?.length) {
        output = output + dimension.measurement?.length;
    }
    if (dimension.measurement?.width) {
        output = output + " x " + dimension.measurement.width;
    }
    if (dimension.measurement?.measurementUnit) {
        output = output + " " + dimension.measurement.measurementUnit;
    }
    return output || "-";
};